<template>
  <div style="width:100%;height:100%;overflow-y:auto;background:#f6f6f6;padding:10px">
    <!-- 供应商汇总 -->
    <div class="card" style="margin-bottom:10px">
      <div style="font-size:14px;font-weight:600;margin-bottom:10px">供应商应付汇总</div>
      <el-table :data="summary" size="small" stripe>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="供应商" prop="GysMc" min-width="160" />
        <el-table-column label="订单数" prop="Dds" width="80" align="right" />
        <el-table-column label="结算总价" width="120" align="right">
          <template #default="{ row }">{{ row.Yfje }}</template>
        </el-table-column>
        <el-table-column label="已付金额" width="120" align="right">
          <template #default="{ row }">
            <span style="color:#67c23a;font-weight:600">{{ row.Yf }}</span>
          </template>
        </el-table-column>
        <el-table-column label="欠款金额" width="120" align="right">
          <template #default="{ row }">
            <span style="color:#f56c6c;font-weight:600">{{ row.Qk }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 应付明细 -->
    <div class="card">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
        <div style="font-size:14px;font-weight:600">应付明细（未结算订单）</div>
        <div style="display:flex;gap:10px">
          <el-button type="primary" size="small" @click="onLoad">刷新</el-button>
        </div>
      </div>
      <el-table :data="list" v-loading="loading" size="small" stripe>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="类型" prop="Source" width="90" />
        <el-table-column label="供应商" prop="GysMc" min-width="120" />
        <el-table-column label="订单编号" prop="Bh" width="180" />
        <el-table-column label="订单状态" prop="DdZt" width="90" />
        <el-table-column label="商品/项目" prop="SpMc" min-width="140" />
        <el-table-column label="结算价" width="100" align="right">
          <template #default="{ row }">{{ row.Jszj }}</template>
        </el-table-column>
        <el-table-column label="已付" width="100" align="right">
          <template #default="{ row }">
            <span style="color:#67c23a;font-weight:600">{{ row.Yfje }}</span>
          </template>
        </el-table-column>
        <el-table-column label="欠款" width="100" align="right">
          <template #default="{ row }">
            <span style="color:#f56c6c;font-weight:600">{{ row.Qk }}</span>
          </template>
        </el-table-column>
        <el-table-column label="返利" width="80" align="right">
          <template #default="{ row }">{{ row.Fl }}</template>
        </el-table-column>
        <el-table-column label="下单时间" width="160">
          <template #default="{ row }">{{ formatTime(row.Cjsj) }}</template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content:flex-end;margin-top:10px">
        <el-pagination
          v-model:current-page="query.page"
          :page-size="query.limit"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="onLoad"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { caiwu_yingfu } from "@/http/api";
import dayjs from "dayjs";

export default {
  setup() {
    const query = reactive({ page: 1, limit: 20 });
    const list = ref([]);
    const summary = ref([]);
    const total = ref(0);
    const loading = ref(false);

    const formatTime = (t) => t ? dayjs(t).format("YYYY-MM-DD HH:mm") : "-";

    const onLoad = () => {
      loading.value = true;
      const params = { page: query.page, limit: query.limit };
      caiwu_yingfu(params).then(res => {
        loading.value = false;
        if (res.status == 200) {
          list.value = res.data.data || [];
          total.value = res.data.total || 0;
          summary.value = res.data.gysSummary || [];
        }
      }).catch(() => { loading.value = false; });
    };

    onMounted(() => onLoad());

    return { query, list, summary, total, loading, onLoad, formatTime };
  },
};
</script>

<style scoped>
.card { background:#fff;border-radius:7px;padding:20px; }
</style>
